<template>
    <section
        if="streamingData"
        class="c-pwa-video"
    >
        <div class="c-pwa-video__title">
            <div
                v-if="streamingData.title"
                class="heading-container"
            >
                <img
                    v-if="streamingData.header_image"
                    class="image"
                    :src="imgSrc(streamingData.header_image)"
                    :alt="streamingData.title"
                >
                <component
                    :is="titleTag || 'h2'"
                    class="title"
                    v-html="textReplacer(streamingData.title, 'hero-title-primary')"
                />
            </div>
        </div>
        <div
            v-if="streamingData.synopsis"
            class="c-pwa-video__synopsis"
        >
            <p>
                {{ streamingData.synopsis }}
            </p>
        </div>
        <y-try-it-yourself
            iframe
            iframe-field="embed_link"
            :content="streamingData"
            :dont-show-content="dontShowContent"
        />
        <div
            v-if="streamingData.custom?.['button-link']"
            class="c-pwa-video__action"
        >
            <y-button
                v-if="!buttonClass"
                color="primary"
                size="medium"
                flat
                :tag="isLink(streamingData.custom['button-link']) ? 'a' : 'router-link'"
                :to="streamingData.custom['button-link']"
                :href="streamingData.custom['button-link']"
            >
                {{ streamingData.custom['button-title'] }}
            </y-button>
            <y-button
                v-else
                :class="{[buttonClass]: !!buttonClass}"
                color="primary"
                size="medium"
                flat
            >
                {{ streamingData.custom['button-title'] }}
            </y-button>
        </div>
    </section>
</template>

<script >
    import { isLink, textReplacer } from '@/helpers/helpers';

    import YTryItYourself from '@modules/home/components/TryItYourself/Index.vue';

    export default {
        name: 'PwaVideo',

        components: {
            YTryItYourself,
        },

        /**
         * @inheritDoc
         */
        props: {
            streamingData  : Object,
            dontShowContent: Boolean,
            titleTag       : String,
            buttonClass    : String,
        },

        /**
         *
         * @inheritDoc
         */
        methods: {
            isLink,
            textReplacer,
        },
    };

</script>

<style lang="scss" src="./index.scss"/>
